import apiFetch from './api-fetch';
import {
  CorpJobInput,
  CorpJobOutput,
} from '@scale/shared/types/corpJobs/AllSharedCorpJobInterfaces';
import {
  HydratedCorpJobJson,
  HydratedCorpJobJsonWithOutput,
} from '@scale/shared/types/corpJobs/HydratedCorpJobJson';

export async function invokeCorpJob<T extends string>(
  name: T,
  jsonInput: CorpJobInput<T>,
): Promise<HydratedCorpJobJsonWithOutput<CorpJobInput<T>, CorpJobOutput<T>>> {
  const job = await apiFetch(null, `corp-api/jobs/${name}`, {
    method: 'POST',
    body: {
      name,
      input: JSON.stringify(jsonInput),
      metadata: {
        reason: `Invoked from ${window.location.href}`,
      },
      isAsync: false,
    },
  });
  return job;
}

export async function invokeAsyncCorpJob<T extends string>(
  name: T,
  jsonInput: CorpJobInput<T>,
): Promise<HydratedCorpJobJsonWithOutput<CorpJobInput<T>, CorpJobOutput<T>>> {
  const job = await apiFetch(null, `corp-api/jobs/${name}`, {
    method: 'POST',
    body: {
      name,
      input: JSON.stringify(jsonInput),
      metadata: {
        reason: `Invoked from ${window.location.href}`,
      },
      isAsync: true,
    },
  });
  return job;
}

type DynamicCorpJobOutput = {
  message: string;
  stepFunctionId?: string;
  componentProps?: object;
};

export const invokeDynamicCorpJob = async (
  name: string,
  jsonInput: object,
  isAsync = false,
  isPoll = false,
  isToolbox?: boolean,
): Promise<HydratedCorpJobJsonWithOutput<object, DynamicCorpJobOutput>> => {
  const path = isToolbox ? `toolbox/${name}` : `jobs/${name}-dynamicCorpJob`;
  const job = await apiFetch(null, `corp-api/${path}`, {
    method: 'POST',
    body: {
      name,
      input: JSON.stringify(jsonInput),
      metadata: {
        reason: 'Used Dynamic Corp Page',
      },
      isAsync,
      isPoll,
    },
  });
  return job;
};

export async function fetchCorpJob(corpJobId: string) {
  return apiFetch<HydratedCorpJobJson>(null, `corp-api/jobs/job/${corpJobId}`);
}
